@if (playingAudio && !completedSection) {
  <app-audio
    [items]="ratingList"
    [question]="question"
    [skipToEnd]="skipToEnd"
    [startAt]="startAt"
    (endSection)="onEndSection($event)"
    (playedMedia)="onPlayedMedia($event)"
    (startedMedia)="onStartedMedia($event)"
    (finishedMedia)="onFinishedMedia($event)"
    (emitRating)="onEmitRating($event)"
    [previewing]="previewing"
  ></app-audio>
}

@if (playingVideo && !completedSection) {
  @if (isBunny) {
    <app-bunny-rating-video
      (mouseleave)="onMouseleave($event)"
      (mouseenter)="onMouseenter($event)"
      [startAt]="startAt"
      [items]="ratingList"
      [question]="question"
      [skipToEnd]="skipToEnd"
      (endSection)="onEndSection($event)"
      (emitRating)="onEmitRating($event)"
      (playedMedia)="onPlayedMedia($event)"
      (startedMedia)="onStartedMedia($event)"
      (finishedMedia)="onFinishedMedia($event)"
      [previewing]="previewing"
    ></app-bunny-rating-video>
  } @else {
    <app-video
      (mouseleave)="onMouseleave($event)"
      (mouseenter)="onMouseenter($event)"
      [startAt]="startAt"
      [items]="ratingList"
      [question]="question"
      [skipToEnd]="skipToEnd"
      (endSection)="onEndSection($event)"
      (emitRating)="onEmitRating($event)"
      (playedMedia)="onPlayedMedia($event)"
      (startedMedia)="onStartedMedia($event)"
      (finishedMedia)="onFinishedMedia($event)"
      [previewing]="previewing"
    ></app-video>
  }
}

<app-progress-bar [progressValue]="controller.getProgress()"></app-progress-bar>
